import type { Meeting } from '../api/types.js';

// The Meetings page's days (ADR-037): the coming meetings first, soonest first, then the past days, latest first

const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });

export const startOf = (m: Meeting) => (m.allDay ? new Date(`${m.start}T00:00:00`) : new Date(m.start));
const dayKey = (d: Date) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

/** « Today », « Tomorrow », « Yesterday », else the day's name */
function dayLabel(d: Date, now: Date): string {
  const diff = Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime() - new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()) / 86_400_000);
  return diff === 0 ? 'Today' : diff === 1 ? 'Tomorrow' : diff === -1 ? 'Yesterday' : dayName.format(d);
}

/** The meetings by day: the coming ones first, soonest first; then the past days, the latest first */
export function byDay(meetings: Meeting[], now: Date): Array<{ key: string; label: string; meetings: Meeting[] }> {
  const upcoming = meetings.filter((m) => new Date(m.end || m.start).getTime() >= now.getTime()).sort((a, b) => startOf(a).getTime() - startOf(b).getTime());
  const past = meetings.filter((m) => new Date(m.end || m.start).getTime() < now.getTime()).sort((a, b) => startOf(b).getTime() - startOf(a).getTime());
  const coming = new Set(upcoming);
  const groups: Array<{ key: string; label: string; meetings: Meeting[] }> = [];
  for (const m of [...upcoming, ...past]) {
    const d = startOf(m);
    const key = `${coming.has(m) ? 'u' : 'p'}${dayKey(d)}`;
    const group = groups.find((g) => g.key === key);
    if (group) group.meetings.push(m);
    else groups.push({ key, label: dayLabel(d, now), meetings: [m] });
  }
  return groups;
}
